import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useFetchData from '../hooks/useFetchData';
import { getFinalizedTranscriptsDetails } from '../../services/transcriptsService';
import useSchools from '../hooks/useSchools';
import { TRANSCRIPTS_CATEGORIES } from '../../constants';
import Loader from '../reusable/Loader';
import { getSubjectAreas } from '../../services/eoaConfigServices';
import SubjectAreaTable from './transcriptsBySubjectArea/SubjectAreaTable';
import { parseTranscriptsBySubjectArea, hasCoursesInSubjectArea } from './transcriptsBySubjectArea/utils';
import { SubjectAreaNames } from '../../interfaces/EOAInterface';
import CustomAlert from '../reusable/CustomAlert';

import './TranscriptsBySubjectArea.css';

function TranscriptsBySubjectArea() {
  const { transcriptSelectionSchool } = useSchools();

  const {
    isPending: isTranscriptsDataPending,
    error: transcriptsDataError,
    data: transcriptsData,
  } = useFetchData({
    fetchData: (eoaId, access_token) => getFinalizedTranscriptsDetails(eoaId, access_token, transcriptSelectionSchool),
    errorMessage: 'Error occured while fetching transcripts details!',
    initialState: {
      is_finalized: false,
      transcripts: {
        [TRANSCRIPTS_CATEGORIES.RIGOROUS_ACADEMIC]: [],
        [TRANSCRIPTS_CATEGORIES.ON_THE_CUSP]: [],
        [TRANSCRIPTS_CATEGORIES.STRUGGLING]: [],
      },
    },
  });

  const {
    isPending: isSubjectAreasDataPending,
    error: subjectAreasDataError,
    data: subjectAreasData,
  } = useFetchData({
    fetchData: (eoaId, access_token) => getSubjectAreas(access_token),
    errorMessage: 'Error occured while fetching transcripts details!',
    initialState: [],
  });

  if (isTranscriptsDataPending || isSubjectAreasDataPending) return <Loader />;
  if (transcriptsDataError || subjectAreasDataError)
    return <p className="center-text">Error occured while fetching transcripts details!</p>;

  const parsedData = parseTranscriptsBySubjectArea(
    transcriptsData.transcripts,
    subjectAreasData.map(({ name }) => name)
  );

  return (
    <>
      <div className="transcripts-view-header">
        <h2>Transcript view by subject area</h2>
      </div>
      <div className="transcripts-view-body">
        {(Object.keys(parsedData) as SubjectAreaNames[]).map((subjectAreaName) => (
          <Accordion key={subjectAreaName} className="subject-area-accordion">
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
              {subjectAreaName}
            </AccordionSummary>
            <AccordionDetails className="subject-area-details">
              {hasCoursesInSubjectArea(parsedData[subjectAreaName]) ? (
                <SubjectAreaTable data={parsedData[subjectAreaName]} />
              ) : (
                <CustomAlert alertType="warning" header="No classes found in this subject area." />
              )}
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </>
  );
}

export default TranscriptsBySubjectArea;
